import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Button, Modal,  } from 'react-bootstrap';
import { Form } from 'ui/components';
import cn from 'classnames';
import { FormReceive } from './component/receive';

import { ShipmentCustomer } from 'services/action';

const initialState = {
  showModal: false,
  showShipment: false,
  shipment: null,
  code: '',
  isError: false
};

const ScannerShipmentScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const [{ showModal, showShipment, shipment, code, isError }, setState] = React.useState(initialState);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Get']
  );

  const $onScan = async(e) => {
    let result = await Dispatch(ShipmentCustomer.$get({ search: code, document_status: 'new', limit: 1 }));
    if (result?.message === 'success' && result?.data !== undefined) {
      setState((prevState) => ({ ...prevState, showShipment: true, shipment: result?.data[0] }));
    } else {
      setState((prevState) => ({ ...prevState, isError: true }));
    }
  }

  const $closeShipment = async () => {
    setState((prevState) => ({ ...prevState, showShipment: false, shipment: null, code: '' }));
  };

  const $closeModal = async () => {
    setState((prevState) => ({ ...prevState, showModal: false }));
    History.push(`/order/customer`);
  };

  React.useEffect(() => {
    setState((prevState) => ({ ...prevState, showModal: true }));
  }, []);


  return (
    <>
      <Modal
        show={showModal}
        onHide={$closeModal}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$closeModal} />
          <div className="modal-status bg-primary" />
          <h3>Scan Barcode</h3>
          <Form.Input
            mb0
            value={code}
            onChange={(e) => setState((prevState) => ({ ...prevState, code: e?.target?.value }))}
            type="text"
            placeholder="Masukkan kode shipment"
            error={isError ? 'Kode shipment tidak valid' : false}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$closeModal}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={cn(StateLoading ? 'btn-loading' : '', 'w-100')}
                disabled={code === '' ? true : false}
                onClick={$onScan}
              >
                Cek
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showShipment}
        onHide={$closeShipment}
        backdrop="static"
        centered
        // className="text-center"
        size="xl"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$closeShipment} />
          <h3 className='text-center'>Konfirmasi Shipment</h3>
          <FormReceive
            data={shipment}
            onSubmit={() => {
              $closeShipment();
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ScannerShipmentScreen;
